/* eslint-disable */
export default {
  noActiveCalls: '활성 통화 없음',
  noRecords: '검색 결과가 없습니다.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
